export const production: boolean = false;

export const mediaUrl: string = 'https://media.bizcourier.eu/';
export const payUrl: string = 'https://pay.bizcourier.eu/';
export const serverUrl: string = 'https://rest.bizcourier.eu/';
export const stompUrl: string = 'https://rabbit.bizcourier.eu/';
export const wmsUrl: string = 'https://wms.bizcourier.eu/';